import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template';
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {imageWidget_template} from "./imageWidget_template";
import {imagePicker_template} from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import {imagePickerHelper} from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";

declare var ko: any;

export class merchantsEdit_template extends vnTemplate {

    protected validationsList: validationsList_template;
    protected specialStatusSelector: filterDropdown_template;
    protected categorySelector: multipleSelector_template;
    public imageWidgetForLogo: imageWidget_template;
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;

    protected imagePickerTarget: string = null;

    public static SPECIAL_STATUS_OPTIONS = [
        {id: '', name: 'None'},
        {id: 'veteran_owned', name: 'Veteran Owned'},
        {id: 'spouse_owned', name: 'Spouse Owned'}
    ];

    protected getTemplateHtml(): string {
        return /* html */`
            ${this.validationsList.getHtmlBuild()}
            <div class="form-header">
                <input type="hidden">

                <!-- ko ifnot: id() -->
                <h3 class="form-title icon i-store">New Merchant</h3>
                <!-- /ko -->

                <!-- ko if: id() -->
                <h3 class="form-title icon i-store" data-bind="text: name"></h3>
                <!-- /ko -->

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
            </div>

            <div class="form-pagination">
                <button class="icon" type="button" data-bind="event: { click: onClickTab.bind($data,'basic') }, css: { 'is-activated' : selectedTab() == 'basic'}"><span class="btn-text">Basic Info</span></button>
                <button class="icon" type="button" data-bind="event: { click: onClickTab.bind($data,'details') }, css: { 'is-activated' : selectedTab() == 'details'}"><span class="btn-text">Details & Categories</span></button>
                <button class="icon" type="button" data-bind="event: { click: onClickTab.bind($data,'tracking') }, css: { 'is-activated' : selectedTab() == 'tracking'}"><span class="btn-text">Tracking</span></button>
            </div>

            <!-- Basic Info Tab -->
            <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'basic'}">
                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title">Basic Information</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Merchant Name <span class="required">*</span></label>
                            <input data-bind="textInput: name" class="input-text" placeholder="Enter merchant name"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Slug</label>
                            <input data-bind="textInput: slug" class="input-text" placeholder="merchant-slug"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Website URL</label>
                            <input data-bind="textInput: websiteUrl" class="input-text" placeholder="https://example.com"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Website URL Label</label>
                            <input data-bind="textInput: websiteUrlLabel" class="input-text" placeholder="Visit Website"/>
                        </div>

                        <div class="form-group">
                            <div class="form-check">
                                <input type="checkbox" id="isActive" data-bind="checked: isActive">
                                <label class="form-label" for="isActive">Active</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Short Description (Blurb)</label>
                            <textarea data-bind="value: blurb" class="input-text" rows="3" placeholder="Brief description of the merchant"></textarea>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Full Description</label>
                            <textarea data-bind="value: description" class="input-text" rows="6" placeholder="Detailed description"></textarea>
                        </div>

                        <div class="form-group">
                            <label class="form-label">Logo Image</label>
                            <div id="merchant_logo"></div>
                            ${this.imageWidgetForLogo.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Details & Categories Tab -->
            <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'details'}">
                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title">Special Status & Categories</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Special Status</label>
                            ${this.specialStatusSelector.getHtmlBuild()}
                        </div>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Categories</label>
                            ${this.categorySelector.getHtmlBuild()}
                            <div id="selected-categories" class="tags-container"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tracking Tab -->
            <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'tracking'}">
                <div class="w-form-body">
                    <div class="form-body full-width">
                        <strong class="form-sub-title">Tracking Pixels (JSON)</strong>
                    </div>
                </div>

                <div class="w-form-body">
                    <div class="form-body full-width">
                        <div class="form-group">
                            <label class="form-label">Tracking Pixels (JSON format)</label>
                            <textarea data-bind="value: trackingPixelsJson" class="input-text" rows="8" placeholder='[{"type": "pixel", "url": "https://..."}]'></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn border" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save Merchant</button>
            </div>

            ${this.imagePicker.getHtmlBuild()}
        `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationsList", this.getTemplateViewModel(), this.caller);

        this.specialStatusSelector = new filterDropdown_template("specialStatusSelector", this.getTemplateViewModel(), this.caller);
        this.specialStatusSelector.setLabel('Select Special Status');
        this.specialStatusSelector.setOptions(merchantsEdit_template.SPECIAL_STATUS_OPTIONS);

        this.categorySelector = new multipleSelector_template("categorySelector", this.getTemplateViewModel(), this.caller);
        this.categorySelector.setLabel('Select Categories');
        this.categorySelector.setFilterContainerClass('margin-neg');
        this.categorySelector.setTagContainerId('selected-categories');
        this.categorySelector.setTagContainerCaption('Selected Categories:');

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.imageWidgetForLogo = new imageWidget_template("merchant_logo", this.getTemplateViewModel(), this);
        this.imageWidgetForLogo.setMode('single-select');
        this.imageWidgetForLogo.setCaller(this.imagePickerHelper);
    }

    protected getTemplateName(): string {
        return "merchantsEdit_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            id: ko.observable(null),
            name: ko.observable(''),
            slug: ko.observable(''),
            blurb: ko.observable(''),
            description: ko.observable(''),
            websiteUrl: ko.observable(''),
            websiteUrlLabel: ko.observable(''),
            specialStatus: ko.observable(''),
            isActive: ko.observable(true),
            idImage: ko.observable(null),
            logoImageUrl: ko.observable(''),
            trackingPixelsJson: ko.observable(''),
            selectedTab: ko.observable('basic'),
            categories: ko.observableArray([]),

            onClickTab: (tab, data, event) => {
                self.onClickTab(tab);
            },
            onClickSave: (data, event) => {
                self.onClickSave();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            }
        };
    }

    protected onClickTab(tab: string): void {
        this.getTemplateViewModel().selectedTab(tab);
    }

    protected onClickSave(): void {
        this.caller.save();
    }

    protected onClickCancel(): void {
        this.caller.cancel();
    }

    public clearMessages(): void {
        this.validationsList.clearMessages();
    }

    public getViewModelForRequest(): any {
        const vm = this.getTemplateViewModel();
        let trackingPixels = null;
        try {
            const raw = vm.trackingPixelsJson();
            if (raw && raw.trim()) {
                trackingPixels = JSON.parse(raw);
            }
        } catch (e) {
            // leave as null if invalid JSON
        }

        return {
            id: vm.id(),
            name: vm.name(),
            slug: vm.slug(),
            blurb: vm.blurb(),
            description: vm.description(),
            websiteUrl: vm.websiteUrl(),
            websiteUrlLabel: vm.websiteUrlLabel(),
            specialStatus: this.specialStatusSelector.getTemplateViewModel().selectedOption() || null,
            isActive: vm.isActive(),
            idImage: vm.idImage(),
            trackingPixels: trackingPixels,
            categoryIds: this.categorySelector.getSelectedItems()
        };
    }

    public setCategoryOptions(categories: any[]): void {
        this.categorySelector.setItems(categories);
    }

    public setMerchantData(merchant: any): void {
        const vm = this.getTemplateViewModel();

        vm.id(merchant.id);
        vm.name(merchant.name || '');
        vm.slug(merchant.slug || '');
        vm.blurb(merchant.blurb || '');
        vm.description(merchant.description || '');
        vm.websiteUrl(merchant.websiteUrl || '');
        vm.websiteUrlLabel(merchant.websiteUrlLabel || '');
        vm.isActive(merchant.isActive !== false);

        // Set special status
        if (merchant.specialStatus) {
            this.specialStatusSelector.setSelectedOption(merchant.specialStatus);
        }

        // Set selected categories
        if (merchant.categories && merchant.categories.length > 0) {
            this.categorySelector.setSelectedItems(merchant.categories);
        }

        // Set image
        if (merchant.image) {
            vm.idImage(merchant.image.id);
            vm.logoImageUrl(merchant.image.url);
            this.imageWidgetForLogo.setImage(merchant.image);
        }

        // Set tracking pixels
        if (merchant.trackingPixels) {
            vm.trackingPixelsJson(JSON.stringify(merchant.trackingPixels, null, 2));
        }
    }

    public setLogoImage(image: any): void {
        const vm = this.getTemplateViewModel();
        vm.idImage(image.id);
        vm.logoImageUrl(image.url);
        this.imageWidgetForLogo.setImage(image);
    }

    public removeImage(target: string): void {
        const vm = this.getTemplateViewModel();
        if (target === 'merchant_logo') {
            vm.idImage(null);
            vm.logoImageUrl('');
            this.imageWidgetForLogo.clearImage();
        }
    }

    public updateSelectedCategories(): void {
        // Categories are automatically updated via the multipleSelector
    }

    public setImagePickerTarget(target: string): void {
        this.imagePickerTarget = target;
    }

    public getImagePickerTarget(): string {
        return this.imagePickerTarget;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/merchantsEdit_template.ts